module.exports = __webpack_public_path__ + "static/media/Instagram.dfc5fa53.svg";